// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index";

import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { RadarChart } from 'echarts/charts';

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import * as VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import VIcon from 'vue-tailwind-icons';
import VueCurrencyInput from 'vue-currency-input';
import VueHtmlToPaper from 'vue-html-to-paper';
import PerfectScrollbar from "vue2-perfect-scrollbar";
// Make BootstrapVue available throughout your project
import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree)

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VIcon, { set: 'outline' });


import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";


import { MdIcon } from "vue-material/dist/components";

Vue.use(MdIcon);
Vue.use(VueCurrencyInput, {
  globalOptions: { currency: 'USD' }
})

import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ModelSelect } from 'vue-search-select'

import eBar  from '@/components/Charts/Bar';
import ePie  from '@/components/Charts/Pie'
// Chart Custom 
Vue.component("chart-bar", eBar);
Vue.component("chart-pie", ePie);


library.add(fas);
Vue.component("vue-select-2", ModelSelect);
Vue.component("vue-fontawesome", FontAwesomeIcon);
Vue.component('fa-icon', FontAwesomeIcon)
import "vue-material/dist/vue-material.min.css";


const options = {
  name :'_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'static/css/bootstrap.min.css', 
    'static/css/potrait.css',
    'static/css/1-print.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
Vue.use(VueHtmlToPaper, options);
// Bootstrap
import  "./assets/plugins/bootstrap/css/bootstrap.min.css";
// Custom Style
import customStyle from "./assets/css/style.css";
import "./assets/css/legacy.css";
// Color
import colorStyle from "./assets/css/colors/colors.css";
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-search-select/dist/VueSearchSelect.css'
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
// Simple line icon
//import  "./assets/css/icons/simple-line-icons/css/simple-line-icons.css";

// import ECharts modules manually to reduce bundle size
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  BarChart ,
  PieChart
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
   LegendComponent,

} from 'echarts/components'

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  RadarChart,
  GridComponent,
  TooltipComponent ,
  LegendComponent, 
  TitleComponent
]);


Vue.use(customStyle);
Vue.use(colorStyle);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
Vue.component('v-chart', ECharts)
// Layout Import
import LandingLayout from "./layout/Landing.vue";

// Layout Usage
Vue.component("landing-layout", LandingLayout);
Vue.use(PerfectScrollbar);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js